import React from 'react';

var useRefocusOnActivator$1 = {};

Object.defineProperty(useRefocusOnActivator$1, "__esModule", { value: true });
var useRefocusOnActivator_2 = useRefocusOnActivator$1.useRefocusOnActivator = void 0;
const react_1 = React;
/**
 * Brings back the focus to the element that opened an overlaid element once
 * said overlaid element is dismissed.
 *
 * @param active - Determines if it should focus or not
 */
function useRefocusOnActivator(active) {
    (0, react_1.useEffect)(() => {
        let activator;
        if (active && !activator) {
            activator = document.activeElement;
        }
        return () => {
            if (active) {
                if (activator instanceof HTMLElement) {
                    activator.focus();
                }
                activator = undefined;
            }
        };
    }, [active]);
}
useRefocusOnActivator_2 = useRefocusOnActivator$1.useRefocusOnActivator = useRefocusOnActivator;

export { useRefocusOnActivator_2 as u };
